import React from 'react';
import { useTranslation } from 'react-i18next';
import { setHostContext } from '../../redux/features/hostContext/hostContextSlice';
import { useAppDispatch, useAppSelector } from '../../redux/app/hooks';
import { RootState } from '../../redux/app/store';
import {
    Menu,
    MenuItem,
    MenuList,
    MenuPopover,
    MenuTrigger,
    makeStyles,
    mergeClasses,
} from '@fluentui/react-components';
import { LanguageFlag } from './LanguageFlag';
import { hostContextStorage } from '../../libs/hostContextStorage';

const useClasses = makeStyles({
    languageButton: {
        fontWeight: 'bold',
    },
    flagIcon: {
        marginRight: '8px',
        fontSize: '1.2em',
    },
    menuTriggerContent: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
    },
});

export const LanguageSwitcher: React.FC = () => {
    const { i18n } = useTranslation();
    const classes = useClasses();
    const dispatch = useAppDispatch();
    const hostContext = useAppSelector((state: RootState) => state.hostContext.hostContext);

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng).catch((e: unknown) => {
            console.error('Error changing language', e);
        });

        const newCtx = { ...hostContext, language: lng };
        dispatch(setHostContext(newCtx));
        hostContextStorage.save(newCtx, false);
        return true;
    };
    return (
        <Menu>
            <MenuTrigger disableButtonEnhancement>
                <MenuItem>
                    Language&nbsp;
                    <LanguageFlag countryCode="gb" className={classes.flagIcon} square />
                    <LanguageFlag countryCode="se" className={classes.flagIcon} square />
                    <LanguageFlag countryCode="nl" className={classes.flagIcon} square />
                </MenuItem>
            </MenuTrigger>

            <MenuPopover>
                <MenuList>
                    <MenuItem
                        className={mergeClasses(i18n.language === 'en' && classes.languageButton)}
                        onClick={() => changeLanguage('en')}
                    >
                        <LanguageFlag countryCode="gb" className={classes.flagIcon} />
                        English
                    </MenuItem>
                    <MenuItem
                        className={mergeClasses(i18n.language === 'sv' && classes.languageButton)}
                        onClick={() => changeLanguage('sv')}
                    >
                        <LanguageFlag countryCode="se" className={classes.flagIcon} />
                        Svenska
                    </MenuItem>
                    <MenuItem
                        className={mergeClasses(i18n.language === 'nl' && classes.languageButton)}
                        onClick={() => changeLanguage('nl')}
                    >
                        <LanguageFlag countryCode="nl" className={classes.flagIcon} />
                        Nederlands
                    </MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};
